import React, { useState } from 'react';
import { Box, List, Popover } from '@mui/material';
import { getTheme } from '../../Theme/ThemeProvider';
import DynamicLogo from '../DynamicLogo';
import { ReportBug } from '../MenuBar/ReportBug';
import { StyledSidebar } from './LeftSideMenu.styles';
import { MenuItem } from './MenuItem';
import { getMenuItems } from './MenuConfig';

/**
 * Left side menu component for the application
 */
export const LeftSideMenu = () => {
  const theme = getTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activeSubmenuIndex, setActiveSubmenuIndex] = useState<number | null>(null);

  const handleBugReportOpen = (event?: React.MouseEvent<HTMLLIElement>) => {
    if (event) {
      setAnchorEl(event.currentTarget);
    }
  };
  
  const handleBugReportClose = () => {
    setAnchorEl(null);
  };
  
  const open = Boolean(anchorEl);

  const handleMouseEnter = (index: number) => {
    setActiveSubmenuIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveSubmenuIndex(null);
  };

  // Get menu items with configuration
  const menuItems = getMenuItems(handleBugReportOpen);
  
  // Get last item (Bug Report) and update its action
  const bugReportItem = { 
    ...menuItems[menuItems.length - 1],
    action: handleBugReportOpen
  };
  
  // Replace the last item with updated Bug Report item
  const updatedMenuItems = [...menuItems.slice(0, -1), bugReportItem];


  return (
    <StyledSidebar theme={theme}>
      <DynamicLogo type={'TOPBAR'} />

      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'start', mt: '48px'}}>
        <List sx={{ width: '100%', padding: 0 }}>
          {updatedMenuItems.filter(el => el.turnedOn).map((item, index) => (
            <MenuItem
              key={index}
              item={item}
              index={index}
              activeSubmenuIndex={activeSubmenuIndex}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          ))}
        </List>
      </Box>
      
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleBugReportClose}
        sx={{
          width: '500px'
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <ReportBug handleClose={handleBugReportClose} />
      </Popover>
    </StyledSidebar>
  );
};